import React from "react";
import "./sfaTrustedBrands.css";

import brand1 from "../../assets/clients/procuremaster_logo_transparent.png";
import brand2 from "../../assets/clients/chatakdarLogo.png";
import brand3 from "../../assets/clients/tauciesLogo.png";
import brand4 from "../../assets/clients/rahejaLogo.png";
import brand5 from "../../assets/clients/mallowsLogo.png";
import brand6 from "../../assets/clients/iora.png";

const logos = [
    {
        src: brand1,
        alt: "Procure Master",
        variant: "light",
    },
    {
        src: brand2,
        alt: "Chatakdar",
        variant: "light",
    },
    {
        src: brand3,
        alt: "Taucies",
        variant: "dark",
    },
    {
        src: brand4,
        alt: "Raheja Realty",
        variant: "light",
    },
    {
        src: brand5,
        alt: "Mallows Beverages",
        variant: "light",
    },
    {
        src: brand6,
        alt: "Iora",
        variant: "light",
    },
];

const marqueeLogos = [...logos, ...logos];

const SfaTrustedBrands = () => {
    return (
        <section className="sfa-trusted-section">
            <div className="sfa-trusted-bg-orb sfa-trusted-bg-orb-left"></div>
            <div className="sfa-trusted-bg-orb sfa-trusted-bg-orb-right"></div>

            <div className="container">
                <div
                    className="sfa-trusted-header"
                    data-aos="fade-up"
                >
                    <div className="sfa-trusted-label">
                        <span className="sfa-trusted-label-dot"></span>
                        OUR CLIENTS
                    </div>

                    <h2>
                        Trusted by Businesses.
                        <span> Built for Real-World Sales.</span>
                    </h2>

                    <p>
                        From customer engagement to field execution,
                        TechCognics helps businesses bring everyday sales
                        operations together through connected digital
                        workflows.
                    </p>
                </div>

                <div
                    className="sfa-client-ribbon"
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    <div className="sfa-client-ribbon-top">
                        <div className="sfa-ribbon-title">
                            <span className="sfa-ribbon-live-dot"></span>
                            <span>POWERING BUSINESSES WITH TECHCOGNICS</span>
                        </div>

                        <div className="sfa-ribbon-index">
                            06+ CLIENT BRANDS
                        </div>
                    </div>

                    <div className="sfa-client-marquee">
                        <div className="sfa-marquee-fade sfa-marquee-fade-left"></div>
                        <div className="sfa-marquee-fade sfa-marquee-fade-right"></div>

                        <div className="sfa-client-track">
                            {marqueeLogos.map((logo, index) => (
                                <div
                                    className={`sfa-client-card ${
                                        logo.variant === "dark"
                                            ? "sfa-client-card-dark"
                                            : ""
                                    }`}
                                    key={`${logo.alt}-${index}`}
                                >
                                    <img
                                        src={logo.src}
                                        alt={logo.alt}
                                        loading="lazy"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="sfa-client-ribbon-bottom">
                        <span className="sfa-ribbon-line"></span>

                        <span>
                            Connected teams
                            <strong> • </strong>
                            Connected operations
                            <strong> • </strong>
                            Connected growth
                        </span>

                        <span className="sfa-ribbon-line"></span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SfaTrustedBrands;